import React from 'react'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'

export default function ContentCodeSection ({ name, code }) {
  return (
    <UI.SpaceBetween>
      <UI.Text>
        [{code}]
      </UI.Text>
      <UI.Text>
        <Translation name={`fields.emailcontent.fields.${name}`} />
      </UI.Text>
    </UI.SpaceBetween>
  )
}
